import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Newssection from '../components/Newssection';
const News = () => {
    return (
        <div>
            <Header />
            <Newssection />
            <Footer />
        </div>
    );
};

export default News;